import { render, staticRenderFns } from "./DailyLaborRecord.vue?vue&type=template&id=cd1638b4"
import script from "./DailyLaborRecord.vue?vue&type=script&lang=js"
export * from "./DailyLaborRecord.vue?vue&type=script&lang=js"
import style0 from "./DailyLaborRecord.vue?vue&type=style&index=0&id=cd1638b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports